module.exports = require('./base').extend();



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-inject/src/index.js
// module id = GeUp
// module chunks = 0